module.exports = __webpack_public_path__ + "img/asus-rogphone-2.71a7758d.jpg";